import FormElement from "../formElements/formElement";
import {Capability} from "../formElements/formElementCapability";

interface FormulaField {
  parentTypes: Array<string>;
  capability: Capability;
}

export default class FormulaFields {
  public static readonly ALL_FIELDS: { [key: string]: FormulaField } = {
    label_title: {
      parentTypes: ['FormElement'],
      capability: Capability.labelable
    },
    default_value: {
      parentTypes: ['FormElement'],
      capability: Capability.defaultable
    },
    min_datetime: {
      parentTypes: ['FormElement'],
      capability: Capability.dateMinMaxable
    },
    max_datetime: {
      parentTypes: ['FormElement'],
      capability: Capability.dateMinMaxable
    },
  };

  public static readonly FORM_ELEMENT_FIELDS = Object.keys(FormulaFields.ALL_FIELDS).filter(
    k => FormulaFields.ALL_FIELDS[k].parentTypes.includes('FormElement'));
}